/* eslint-disable no-param-reassign */
// Helpers below mutate immer drafts in place, so they must only be called from slice reducers
import { Company } from 'Types/CompaniesTypes';

// Unmapped subsidiaries (not set up in xiQ) may come without a valid companyId
export const isMappedSubsidiary = (company: Company) => !!company?.companyId
  && company.companyId > 0;

export const mergeSubsidiaries = (existing: Company[], incoming: Company[]): Company[] => {
  const ids = new Set(existing.filter(isMappedSubsidiary).map((company) => company.companyId));
  const newItems = incoming.filter((company) => {
    if (!isMappedSubsidiary(company)) return true;
    if (ids.has(company.companyId)) return false;
    ids.add(company.companyId);
    return true;
  });
  return [...existing, ...newItems];
};

export const setSubsidiariesFollowLoading = (
  list: Company[],
  companyId: string,
  loading: boolean,
) => {
  const id = parseInt(companyId?.trim(), 10);
  list.forEach((company) => {
    if (company.companyId === id) company.loading = loading;
  });
};

export const updateSubsidiariesFollow = (
  list: Company[],
  companyIds: string[],
  subscribed: boolean,
) => {
  const ids = new Set(companyIds.map((id) => parseInt(id.trim(), 10)));
  list.forEach((company) => {
    if (!ids.has(company.companyId)) return;
    company.loading = false;
    if (company.companySubscribed !== subscribed) {
      company.companySubscribed = subscribed;
      company.companySubscribers = Math.max(
        0,
        (company.companySubscribers || 0) + (subscribed ? 1 : -1),
      );
    }
  });
};

// Unmapped cards have no companyId, so the Request Company state is keyed by subsidiaryItemId
export const setSubsidiaryRequestState = (
  list: Company[],
  subsidiaryItemId: number,
  loading: boolean,
  requested?: boolean,
) => {
  list.forEach((company) => {
    if (company.subsidiaryItemId !== subsidiaryItemId) return;
    company.requestLoading = loading;
    if (requested) company.dataRequested = 1;
  });
};

export const clearSubsidiariesFollowLoading = (list: Company[], companyIds: string[]) => {
  const ids = new Set(companyIds.map((id) => parseInt(id.trim(), 10)));
  list.forEach((company) => {
    if (ids.has(company.companyId)) company.loading = false;
  });
};
